<template>
  <div class="syncAuthority-container">
    <!--主页面 -->
    <div class="flex-row"
         style="height: 100%">
      <div class="section-mian_right">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table ref="accessTab"
                     :data="tableData"
                     :option="tableOption"
                     :page="page"
                     @row-cancle="closeDialog"
                     @row-update="handleUpdate"
                     @search-change="searchResult"
                     @search-reset="resetQuery"
                     @current-change="selectPage"
                     @size-change="changeSize">
            <!-- 搜索框 自定义 -->
            <template slot="search_syncType">
              <el-select v-model="syncType"
                         placeholder="请选择"
                         @change="typeChange">
                <el-option v-for="item in typeOptions"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </template>
            <template slot="search_thirdDeviceName">
              <el-select v-model="deviceId"
                         placeholder="请选择"
                         @change="selectChange">
                <el-option v-for="items in gateOptions"
                           :key="items.deviceId"
                           :label="items.thirdDeviceName"
                           :value="items.deviceId">
                </el-option>
              </el-select>
            </template>
            <!-- 表格按钮 自定义 -->
            <template slot="menu"
                      slot-scope="scope">
              <el-tooltip class="item"
                          effect="dark"
                          content="来源详情"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           icon="el-icon-view"
                           @click="sourceView(scope.row, scope.index)"></el-button>
              </el-tooltip>
              <el-tooltip class="item"
                          effect="dark"
                          content="详情"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           icon="iconfont icon-Detail"
                           @click="handleView(scope.row, scope.index)"></el-button>
              </el-tooltip>
              <el-tooltip class="item"
                          effect="dark"
                          content="同步"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           v-auth="'/authorizationSync/index:reload'"
                           icon="iconfont-lunan icon-lunan-refresh"
                           @click="reloadSyncData(scope.row, scope.index)"></el-button>
              </el-tooltip>
            </template>
            <!-- 表格列 自定义 -->
            <template slot="fileCode"
                      slot-scope="scope">
              <img :src="getImgPath(scope.row.fileCode)"
                   onerror="this.src='/images/theme/newDark/default.png'"
                   style="height: 50px; width: 50px"
                   @click="
                  showViewer(getImgPath(scope.row.fileCode), $event)
                " />
            </template>
            <!-- 同步（修改）表单 自定义 -->
            <template slot="fileCodeForm">
              <el-upload action="common/file/batchFileload.json"
                         class="el-upload-single"
                         :file-list="fileList"
                         ref="addAvatar"
                         :multiple="false"
                         name="files"
                         :show-file-list="true"
                         :list-type="'picture-card'"
                         accept="image/png, image/jpg, image/jpeg, image/bpm"
                         :auto-upload="true"
                         :disabled="false"
                         :limit="1"
                         :before-upload="beforeAvatarUpload"
                         :on-success="handleSuccess"
                         :on-change="handleChangeFile"
                         :on-remove="handleRemove"
                         :on-exceed="handleExceed">
                <i class="el-icon-plus"></i>
              </el-upload>
            </template>
            <!-- 查看详情表单 自定义 -->
            <template slot="fileCodeView"
                      slot-scope="scope">
              <img :src="getImgPath(scope.row.fileCode)"
                   onerror="this.src='/images/theme/newDark/default.png'"
                   style="height: 50px; width: 50px"
                   @click="
                  showViewer(getImgPath(scope.row.fileCode), $event)
                " />
            </template>
          </ioc-table>
          <el-dialog title="预约详情"
                     :visible.sync="detailVisible"
                     v-dialogDrag
                     width="40%"
                     class="detail-continer">
            <el-scrollbar style="height:calc(100vh - 335px)">
              <el-form>
                <ioc-tab-group :option="tabOption"
                               @change="handleChange"></ioc-tab-group>
                <div v-if="detailData">
                  <div v-if="selector.prop === 'tab1' && detailData.type === '1'">
                    <el-row>
                      <el-col :span="24"
                              style="height:100px;">
                        <el-form-item label="访客照片：">
                          <img :src="imgPath(detailData.fileCode)"
                               @click="showViewer(imgPath(detailData.fileCode), $event)"
                               class="stranger_img"
                               onerror="this.src='/images/theme/newDark/default.png'" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="姓名：">
                          {{detailData.name}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="性别：">
                          {{ detailData.sex | sexFilter }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="电话：">
                          {{detailData.phone}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="身份证：">
                          {{ detailData.idCard }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="车牌号：">
                          {{detailData.plateCode}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="车辆颜色：">
                          {{ detailData.vehicleColor | colorFilter }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="车辆类型：">
                          {{ detailData.vehicleType | vehicleTypeFilter }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="接待人姓名：">
                          {{ detailData.receiverName }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="接待人电话：">
                          {{ detailData.receiverPhone }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="入厂时间：">
                          {{ detailData.enterTime }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="出厂时间：">
                          {{ detailData.exitTime }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="厂内 / 厂外：">
                          {{ isFactoryFormatter(detailData.isFactory) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="来访事由：">
                          {{ detailData.visitorReason }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="通行区域：">
                          {{ detailData.areaInfoStr }}
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-if="selector.prop === 'tab1' && detailData.type === '2'">
                    <el-row>
                      <el-col :span="24"
                              style="height:100px;">
                        <el-form-item label="车辆照片：">
                          <img :src="imgPath(detailData.fileCode)"
                               @click="showBigImg(imgPath(detailData.fileCode), $event)"
                               class="stranger_img"
                               onerror="this.src='/images/theme/newDark/default.png'" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="车牌号：">
                          {{ detailData.plateCode }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="姓名：">
                          {{detailData.name}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="工号：">
                          {{ detailData.workNo }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="电话：">
                          {{detailData.phone}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="身份证：">
                          {{ detailData.idCard }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="车辆类型：">
                          {{ detailData.vehicleType | vehicleTypeFilter }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="车辆颜色：">
                          {{ detailData.vehicleColor | colorFilter }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="来访事由：">
                          {{ detailData.visitorReason }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="通行区域：">
                          {{ detailData.areaInfoStr }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="审批意见：">
                          {{ detailData.remark }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="驾驶证：">
                          <div class="driver-img-container"
                               v-for="(item, index) in detailData.driverCardFileCodeList"
                               :key="index">
                            <img :src="imgPath(item)"
                                 @click="showBigImg(imgPath(item), $event)"
                                 class="stranger_img"
                                 onerror="this.src='/images/theme/newDark/default.png'" />
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="行驶证：">
                          <img :src="imgPath(detailData.vehicleCardFileCode)"
                               @click="showBigImg(imgPath(detailData.vehicleCardFileCode), $event)"
                               class="stranger_img"
                               onerror="this.src='/images/theme/newDark/default.png'" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-if="selector.prop === 'tab2' && detailData.type === '1'">
                    <p v-if="detailData.partnterList && detailData.partnterList.length === 0"
                       style="line-height: 50px;">无随行人员</p>
                    <el-row v-for="(item, ind) in detailData.partnterList"
                            :key="ind"
                            v-else
                            class="entourage-container">
                      <el-col :span="24"
                              style="height:100px;">
                        <el-form-item label="照片：">
                          <img :src="imgPath(item.partnerUrl)"
                               @click="showViewer(imgPath(item.partnerUrl), $event)"
                               class="stranger_img"
                               onerror="this.src='/images/theme/newDark/default.png'" />
                        </el-form-item>

                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="姓名：">
                          {{item.name}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="性别：">
                          {{ item.sex | sexFilter }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="电话：">
                          {{item.phone}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="身份证：">
                          {{ item.idCard }}
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                  <el-row v-if="selector.prop === 'tab3'">
                    <div class="process-container">
                      <el-timeline direction="vertical">
                        <el-timeline-item v-for="(flowItem, index) in workFlowDetail"
                                          :key="index"
                                          placement="top">
                          <el-card>
                            <div class="process-step-content">
                              <div class="left-box">
                                <p class="lh30">{{flowItem.type | flowTypeFilter}}</p>
                                <p class="lh30"
                                   v-if="flowItem.type === '3'">{{'('+flowItem.areaDevGroupName+')'}}</p>
                                <p class="lh30">{{flowItem.operatorName}}</p>
                              </div>
                              <div class="right-box"
                                   style="width:150px;">
                                <p class="lh30"> {{flowItem.operatTime}}</p>
                                <p class="lh30">{{flowItem.status | flowStatusFilter}}</p>
                                <span class="detail-text"
                                      v-if="flowItem.status !== '0' && flowItem.status !== '99' && detailData.type === '1'"
                                      @click.stop="cardClick(flowItem)">查看详情</span>
                              </div>
                            </div>
                          </el-card>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </el-row>
                </div>

              </el-form>
            </el-scrollbar>
          </el-dialog>
          <el-dialog title="工作流详情"
                     :visible.sync="singleDetailVisible"
                     v-dialogDrag
                     width="30%">
            <el-form>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="通行区域："
                                v-if="(workFlowType === '1') && detailData.isFactory === '0'">
                    {{singleWorkFlowDetail.areaDevGroupNames}}
                  </el-form-item>

                </el-col>
                <el-col :span="24">
                  <el-form-item label="通行道闸："
                                v-if="(workFlowType === '1') && detailData.isCar === '1'">
                    {{singleWorkFlowDetail.vehicleBarrierThirdDeviceNames}}
                  </el-form-item>

                </el-col>
                <el-col :span="24">
                  <el-form-item label="抄送人员："
                                v-if="(workFlowStatus === '5' || workFlowStatus === '7') && workFlowType === '4'">
                    {{singleWorkFlowDetail.copySendName}}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="通行生效时间："
                                v-if="(workFlowType === '1' || workFlowType === '2') && detailData.isCar === '1'">
                    {{singleWorkFlowDetail.vehicleBarrierEffectiveTime}}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="通行失效时间："
                                v-if="(workFlowType === '1' || workFlowType === '2') && detailData.isCar === '1'">
                    {{singleWorkFlowDetail.vehicleBarrierExpirationTime}}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="remarkText + '：'">
                    {{singleWorkFlowDetail.remark}}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="操作时间：">
                    {{singleWorkFlowDetail.operatTime}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-dialog>

          <viewer @inited="inited"
                  :images="viewerPhotos"
                  class="viewer"
                  ref="viewer">
            <img v-for="src in viewerPhotos"
                 :src="src"
                 :key="src" />
          </viewer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../api/index";
import { Dic, Bus, Dates } from "$utils";
import utils from "$utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../config/table";
export default {
  components: {
  },
  filters: {
    sexFilter (val, SENU) {
      return Dic.findByValue("SENU018", val);
    },
    colorFilter (val) {
      return Dic.findByValue("SENU039", val);
    },
    vehicleTypeFilter (val) {
      return Dic.findByValue("SENU038", val);
    },
    formartterTime (time) {
      return time
        ? Dates.dayjs(Number(time)).format("YYYY-MM-DD HH:mm:ss")
        : "";
    },
    flowTypeFilter (val) {
      return Dic.findByValue("SENU080002", val);
    },
    flowStatusFilter (val) {
      return Dic.findByValue("SENU080003", val);
    }
  },
  data () {
    return {
      detailVisible: false,
      viewerPhotos: [],
      viewerInstance: null,
      tableOption: tableOption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      tableData: [],
      searchParams: {},
      syncType: "",
      deviceId: '',
      typeOptions: [{
        label: '人脸同步',
        value: '1'
      },
      {
        label: '车辆同步',
        value: '2'
      }],
      gateOptions: [],
      fileList: [], // 上传图片数组
      imageUrl: '',
      addUploadBtnDom: null,
      fileCode: '',
      detailData: {},
      workFlowDetail: [],
      tabOption: {
        column: [
          {
            label: '记录信息',
            prop: 'tab1',
          },
          {
            label: '随行人员信息',
            prop: 'tab2',
          },
          {
            label: '流程信息',
            prop: 'tab3',
          },
        ]
      },
      selector: {},
      singleWorkFlowDetail: {},
      // 单个工作流详情
      workFlowStatus: '',
      workFlowType: '',
      remarkText: '',
      singleDetailVisible: false,
    };
  },
  created () {
    this.selector = this.tabOption.column[0];
  },
  mounted () {
    this.getList();
  },
  methods: {
    imgPath (item) {
      return item ? Bus.imgPath(item) : "";
    },
    // 闸机类型下拉框change事件
    typeChange (val) {
      this.deviceId = ''
      if (val === '1') {
        this.getAccessDeviceInfoTree('1')
      } else if (val === '2') {
        this.getAccessDeviceInfoTree('17')
      }
    },
    getAccessDeviceInfoTree (type) {
      const params = {
        deviceType: type,
      };
      // 闸机接口
      this.$fetch(api.getGateTree, params).then((res) => {
        if (res.success) {
          // let obj = {}
          // res.returnObj.forEach((item) => {
          //   obj.value = item.deviceId;
          //   obj.label = item.thirdDeviceName;
          //   this.gateOptions.push(obj)
          // })
          console.log(res.returnObj, '=================')
          this.gateOptions = res.returnObj;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    selectChange (e) {
      console.log('e+++++', e);
    },
    getImgPath (item) {
      return item ? Bus.imgPath(item) : "";
    },
    inited (viewer) {
      this.viewerInstance = viewer;
    },
    showViewer (src, e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [e.target.src.indexOf('default/default.png') == -1 ? e.target.src + "&sourceFileFlag=1" : e.target.src];
      this.viewerInstance.show();
    },
    statusFormatter (data) {
      switch (data.status * 1) {
        // 1:待接待人审批,2:接待人审批通过,待部门负责人审批3:部门负责人审批通过,待区域负责人审批4:区域负责人同意5:拒绝'
        case 1:
          return "待审批";
        case 2:
          return "已通过";
        case 3:
          return "已拒绝";
        default:
          return data.status;
      }
    },
    isFactoryFormatter (data) {
      switch (data * 1) {
        // 
        case 0:
          return "厂内";
        case 1:
          return "厂外";
        default:
          return data;
      }
    },
    // 获取列表
    getList () {
      const params = {};
      params.syncType = this.syncType;
      params.syncDeviceID = this.deviceId;
      params.name = this.searchParams.name;
      params.plateCode = this.searchParams.plateCode;
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      const loading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$fetch(api.getSyncList, params).then((response) => {
        setTimeout(() => {
          loading.close()
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        // this.tableData.forEach(item => {
        //   if (item.syncType === '1') {
        //     item.name = null
        //   }
        // });
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },

    handleView (row, index) {
      this.$refs.accessTab.rowView(row, index);
    },
    sourceView (row, index) {
      this.getView(row.dataID)
    },
    getView (code) {
      this.detailVisible = true;

      let params = {
        appointmentCode: code,
      };
      this.$fetch(api.queryVisitorApplyDetail, params).then((res) => {
        if (res.success) {
          this.detailData = res.returnObj;
          if (this.detailData) {
            if (this.detailData.type === '1') {
              this.tabOption = {
                column: [
                  {
                    label: '记录信息',
                    prop: 'tab1',
                  },
                  {
                    label: '随行人员信息',
                    prop: 'tab2',
                  },
                  {
                    label: '流程信息',
                    prop: 'tab3',
                  },
                ],
              }
            } else {
              this.tabOption = {
                column: [
                  {
                    label: '记录信息',
                    prop: 'tab1',
                  },
                  {
                    label: '流程信息',
                    prop: 'tab3',
                  },
                ],
              }
            }
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
      this.getWorkFlowDetail(params);
    },
    getWorkFlowDetail (params) {
      this.$fetch(api.queryAppointmentWorkflow, params).then((response) => {
        if (!response.success) {
          this.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
          return;
        }
        this.workFlowDetail = response.returnObj
      });
    },
    cardClick (item) {
      this.workFlowStatus = item.status;
      this.workFlowType = item.type;


      if (this.workFlowStatus === '5') {
        this.remarkText = '签到意见'
      } else if (this.workFlowStatus === '7') {
        this.remarkText = '签离意见'
      } else {
        this.remarkText = '审批意见'
      }
      let params = {
        workflowCode: item.workflowCode
      }
      if (item.status === '0' || item.status === '99') {
        return false
      } else {
        this.singleDetailVisible = true;
        this.$fetch(api.singleFlowDetail, params).then((response) => {
          if (!response.success) {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
            return;
          }
          this.singleWorkFlowDetail = response.returnObj
        });
      }
    },
    // 选项卡被选中时触发
    handleChange (column) {
      this.selector = column
    },
    //同步、修改图片
    reloadSyncData (row, index) {
      this.$refs.accessTab.rowEdit(row, index);
      this.fileList = []
      this.syncDataCode = row.syncDataCode
      this.fileCode = row.fileCode
      this.$nextTick(() => {
        this.addUploadBtnDom = this.$refs.addAvatar.$el.childNodes[1]
        if (this.fileCode) {
          this.addUploadBtnDom.style.display = 'none'
          this.fileList.push({ url: this.getImgPath(row.fileCode) })
        }
      })
    },
    handleUpdate (rowInfo, done) {
      const params = {
        syncDataCode: this.syncDataCode,
        fileCode: this.fileCode
      }
      this.$fetch(api.reloadSyncData, params).then((response) => {
        if (response && response.success) {
          this.$message.success('同步成功')
          done()
          this.getList()
        } else {
          this.$message.error(response.msgContent)
        }
      })
    },
    closeDialog () { },

    // 查询按钮事件
    searchResult (param) {
      this.searchParams = Object.assign(param);
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery () {
      this.syncType = ''
      this.deviceId = '';
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage (val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize (val) {
      console.log('---val----', val);
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    beforeAvatarUpload (file) {
      const isImg = ['image/png', 'image/jpg', 'image/jpeg', 'image/bpm'].includes(file.type)
      if (!isImg) this.$message.error('图片类型错误,只能是png/jpg/jpeg/bpm中的一种')
      return isImg
    },
    handleChangeFile (file, fileList) {
      this.addUploadBtnDom.style.display = 'none'
    },
    handleRemove (file, fileList) {
      this.fileCode = ''
      this.fileList = []
      this.addUploadBtnDom.style.display = 'inline-block'
    },
    handleExceed (file, fileList) {
      this.$message({
        showClose: false,
        message: this.$t('base.message.fileExceed'),
        type: 'error',
        duration: 2000,
      })
    },
    handleSuccess (res, file, fileList) {
      if (res.success) {
        this.fileCode = res.returnObj[0].fileId
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.syncAuthority-container {
  width: 100%;
  height: 100%;
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .stranger_img {
    width: 80px;
    height: 80px;
    margin-right: 15px;
  }

  .detail-continer {
    .el-row {
      .el-col {
        height: 30px;
      }

      &:nth-child(2) {
        height: 100px;
      }
    }

    .process-container {
      padding: 10px;

      .el-timeline-item__tail {
        position: absolute;
        left: 6px;
        height: 100%;
        border-left: 2px solid #e4e7ed;
      }

      .el-timeline-item__node--normal {
        left: -1px;
        width: 15px;
        height: 15px;
      }

      .el-card {
        width: 80%;
        // border: 1px solid #EBEEF5;
        // background-color: #FFF;
        @include set_theme_color(border-color, active-border-color);
        @include set_theme_color(background-color, top-menu-bg-color);
        @include set_theme_color(color, font-default-color);
        -webkit-transition: 0.3s;
        transition: 0.3s;
      }

      .process-step-content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .right-box {
          .detail-text {
            display: inline-block;
            cursor: pointer;
            @include set_theme_color(color, font-active-color);
          }
        }
      }
    }
  }

  .lh30 {
    line-height: 30px;
  }
}
</style>
